module.exports = __webpack_public_path__ + "static/cabina-conductor---grada-de-ingreso-7e03b4aaefc068e57aa150e0f6c07cd7.jpg";